import { render, staticRenderFns } from "./IconKickstarter.vue?vue&type=template&id=7f285488&"
import script from "./IconKickstarter.vue?vue&type=script&lang=js&"
export * from "./IconKickstarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports